import { makeStyles } from "@material-ui/core/styles";
import BannerImage from "../../assets/images/fondo-como-usar-mi-plan.png";

const styles = makeStyles(theme => ({
  bannerBackground: {
    marginTop: "75px",
    // backgroundImage: `url(${BannerImage})`,
    backgroundPosition: "center bottom",
    backgroundSize: "cover",
    minHeight: "420px",
    backgroundRepeat: "no-repeat",
    [theme.breakpoints.down("xs")]: {
      minHeight: "520px"
    }
  },
  bannerDescription: {
    position: "absolute",
    background: "white",
    bottom: 0,
    left: "200px",
    padding: "45px 40px 75px 50px",
    opacity: "0.8",
    backgroundColor: "#ffffff",
    [theme.breakpoints.down("md")]: {
      left: "10%"
    },
    [theme.breakpoints.down("sm")]: {
      left: "40px",
      paddingBottom: "45px"
    },
    [theme.breakpoints.down("xs")]: {
      left: "auto",
      padding: " 45px 40px 110px 40px",
      margin: "20px 25px 0px 20px"
    }
  },
  bannerTitle: {
    fontSize: "42px",
    fontWeight: "bold",
    fontStretch: "normal",
    fontStyle: "normal",
    fontFamily: "Trebuchet",
    lineHeight: "1.1",
    color: "#00338d",
    maxWidth: "400px",
    marginBlockStart: "0em",
    marginBlockEnd: "0em",
    [theme.breakpoints.down("xs")]: {
      fontSize: "36px",
      maxWidth: "250px"
    }
  },
  bannersubTitle: {
    fontSize: "22px",
    fontWeight: "normal",
    fontStretch: "normal",
    fontStyle: "normal",
    fontFamily: "Trebuchet",
    lineHeight: "1.4",
    letterSpacing: "-0.44px",
    color: "#333333",
    maxWidth: "436px",
    [theme.breakpoints.down("sm")]: {
      left: "40px",
      maxWidth: "360px",
      marginTop: "30px"
    }
  },
  bannerDescriptionContainer: {
    height: "100%",
    [theme.breakpoints.down("sm")]: {
      display: "flex",
      justifyContent: "center"
    }
  },
  relativeContainer: {
    position: "relative",
    [theme.breakpoints.down("xs")]: {
      marginBottom: "160px"
    }
  },
  bannerDescriptionP: {
    fontSize: "20px",
    fontStyle: "normal",
    fontFamily: "Trebuchet",
    lineHeight: "26px",
    color: "#333333"
  },
  bannerRectangle: {
    width: "10px",
    height: "45px",
    background: "#0073cf",
    position: "absolute",
    top: "45px",
    left: "28px",
    [theme.breakpoints.down("xs")]: {
      top: "40px",
      left: "15px",
      width: "8px",
      height: "40px"
    }
  },
  cardImage: {
    position: "absolute",
    bottom: "-50px",
    right: "15%",
    "& img": {
      width: "160px"
    },
    [theme.breakpoints.down("sm")]: {
      right: "40px"
    },
    [theme.breakpoints.down("xs")]: {
      right: "calc(50% - 80px)",
      bottom: "-160px"
    }
  }
}));

export default styles;
